import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import { get } from '@rails/request.js'

// Connects to data-controller="company-select"
export default class extends Controller {
  static targets = ['item']

  connect() {
    new TomSelect(this.element, {
      create: (input, callback) => {
        get(`/app/companies/new?company[name]=${input}`, { responseKind: 'turbo-stream' })
      },
      render: {
        option: (data, escape) => {
          return this.option(data, escape)
        },
        item: (data, escape) => {
          return this.option(data, escape)
        }
      }
    });
  }

  disconnect() {
    this.select.destroy();
  }

  itemTargetConnected(element) {
    this.element.tomselect.sync()
    this.element.tomselect.setValue(element.value)
  }

  option(data, escape){
    return `<div style="${escape(data.$option.style.cssText)}" class="${escape(
      data.$option.className
    )} !flex gap-2 items-center focus:ring-0 focus:outline-none">${
      data.logo
        ? `<img class="rounded-full h-[24px] w-[24px] cover" src="${data.logo}"/>`
        : '<span class="rounded-full h-[24px] w-[24px]"></span>'
    }${data.text}</div>`
  }
}
